// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"993bbebd8d191dec7415","452":"73a7548094d15b4222da","522":"1911f76add4b0eb13d52","551":"ddaf7054521e895a19d5"}[chunkId] + ".js";
};